(() => {
  if (window.JonisTermsConsent) return;
  const version = '2026-10-04';
  const keys = {
    accepted: 'אישור תקנון האתר',
    time: 'מועד אישור התקנון',
    version: 'גרסת אישור התקנון',
    url: 'קישור התקנון שאושר'
  };
  let accepted = false;
  let saving = false;
  let pendingChecked = false;
  let acceptedAt = '';
  // מצב 'implicit' (שורת טקסט, בלי תיבה) לא נכנס לזרימת התיבה — רק מקבל חותמת זמן בלחיצה
  const hosts = () => [...document.querySelectorAll('[data-jonis-terms-consent]:not([data-mode="implicit"])')];
  function stampImplicit(form) {
    const host = form && document.querySelector('[data-jonis-terms-consent][data-mode="implicit"][data-form-id="' + form.id + '"]');
    if (!host) return false;
    host.querySelector('[data-jonis-terms-time]').value = new Date().toISOString();
    return true;
  }
  const controls = host => {
    const form = document.getElementById(host.dataset.formId);
    return form ? [...form.elements].filter(el => el.name === 'checkout') : [];
  };
  function sync() {
    hosts().forEach(host => {
      const input = host.querySelector('[data-jonis-terms-checkbox]');
      input.checked = saving ? pendingChecked : accepted;
      input.disabled = saving;
      host.querySelector('[data-jonis-terms-time]').value = acceptedAt;
      host.querySelector('[data-jonis-terms-hint]').hidden = accepted;
      controls(host).forEach(button => {
        const blocked = !accepted || saving;
        button.setAttribute('aria-disabled', String(blocked));
        button.dataset.jonisTermsBlocked = String(blocked);
      });
    });
  }
  function message(kind) {
    hosts().forEach(host => {
      const status = host.querySelector('[data-jonis-terms-status]');
      status.textContent = kind ? host.dataset[kind + 'Message'] : '';
      status.hidden = !kind;
      host.classList.remove('is-required');
      if (kind === 'required') {
        void host.offsetWidth;
        host.classList.add('is-required');
      }
      host.querySelector('[data-jonis-terms-checkbox]').setAttribute('aria-invalid', String(kind === 'required' || kind === 'error'));
    });
  }
  async function save(checked, host) {
    if (saving) return;
    accepted = false;
    acceptedAt = '';
    saving = true;
    pendingChecked = checked;
    message('saving');
    sync();
    const time = checked ? new Date().toISOString() : '';
    const attributes = {
      [keys.accepted]: checked ? 'כן' : '',
      [keys.time]: time,
      [keys.version]: checked ? version : '',
      [keys.url]: checked ? host.dataset.policyUrl : ''
    };
    try {
      const response = await fetch(host.dataset.updateUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ attributes })
      });
      if (!response.ok) throw new Error('Terms consent could not be saved');
      const cart = await response.json();
      if (checked && (cart.attributes?.[keys.accepted] !== 'כן' || cart.attributes?.[keys.time] !== time)) {
        throw new Error('Terms consent was not confirmed');
      }
      accepted = checked;
      acceptedAt = time;
      message('');
    } catch (error) {
      accepted = false;
      acceptedAt = '';
      message('error');
      console.error(error);
    } finally {
      saving = false;
      sync();
    }
  }
  function init() {
    hosts().forEach(host => {
      if (host.dataset.termsBound) return;
      host.dataset.termsBound = 'true';
      host.querySelector('[data-jonis-terms-checkbox]').addEventListener('change', event => save(event.target.checked, host));
    });
    sync();
  }
  function hostFor(form) {
    return form && hosts().find(host => host.dataset.formId === form.id);
  }
  function guard(event, host) {
    if (!host || (accepted && !saving)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    message(saving ? 'saving' : 'required');
    if (!saving) {
      host.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
      host.querySelector('[data-jonis-terms-checkbox]').focus({ preventScroll: true });
    }
  }
  document.addEventListener('click', event => {
    const button = event.target.closest('button[name="checkout"],input[name="checkout"]');
    if (button && !stampImplicit(button.form)) guard(event, hostFor(button.form));
  }, true);
  document.addEventListener('submit', event => {
    if (!stampImplicit(event.target)) guard(event, hostFor(event.target));
  }, true);
  document.addEventListener('invalid', event => {
    const host = event.target.closest('[data-jonis-terms-consent]');
    if (!host) return;
    event.preventDefault();
    message('required');
    event.target.focus();
  }, true);
  window.JonisTermsConsent = {
    updateCart(cart) {
      if (cart.item_count === 0 && accepted && !saving) {
        accepted = false;
        acceptedAt = '';
        const host = hosts()[0];
        if (host) save(false, host);
        sync();
      }
    }
  };
  init();
  new MutationObserver(mutations => {
    if (mutations.some(m => [...m.addedNodes].some(node => node.nodeType === 1 &&
      (node.matches('[data-jonis-terms-consent]') || node.querySelector('[data-jonis-terms-consent]'))))) init();
  }).observe(document.body, { childList: true, subtree: true });
  document.addEventListener('shopify:section:load', init);
})();
